import React from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormSectionElements, LOVValues, ProgramContainer } from "../../entities/formTemplateDataType";
import { DialogForDateComponent } from "./DialogforDateComponent";
import { DialogForReadonlyComponent } from "./DialogforReadonlyComponent";
import { DialogForTableComponent } from "./DialogforTableComponent";
import { DialogForTableRuleComponent } from "./DialogforTableRuleComponent";
import { DialogForTextComponent } from "./DialogforTextComponent";
import { DialogForDefaultComponent } from "./DialogforDefaultComponent";
import { DialogforExcelComponent } from "./DialogforExcelComponent";
import { DialogForLabelComponent } from "./DialogforLabelComponent";
import { DialogForButtonComponent } from "./DialogForButtonComponent";
import { DialogForDateTimeComponent } from "./DialogforDateTimeComponent";
import { DialongforAddressComponent } from "./DialogforAddressComponent";
import { DialogForFileComponent } from "./DialogForFileComponent";
import { DialogForFeedbackComponent } from "./DialogforFeedbackComponent";


interface Props {
    ele;
    isEng: boolean;
    callback: (programContainer: ProgramContainer)=> void;

}

interface State {
    dateDialogVisible: boolean
    dateTimeDialogVisible: boolean
    readonlyDialogVisible: boolean
    tableRuleDialogVisible: boolean
    textDialogVisible: boolean
    defaultDialogVisible: boolean;
    excelDialogVisible: boolean;
    confirmDialogVisible: boolean;
    labelDialogVisible:boolean;
    buttonDialogVisible:boolean;
    addressDialogVisible:boolean;
    fileDialogVisible:boolean;
    feedbackDialogVisible:boolean;
}

export class MoreButtonComponent extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            dateDialogVisible: false,
            dateTimeDialogVisible: false,
            readonlyDialogVisible: false,
            tableRuleDialogVisible: false,
            textDialogVisible: false,
            defaultDialogVisible: false,
            excelDialogVisible: false,
            confirmDialogVisible: false,
            labelDialogVisible:false,
            buttonDialogVisible:false,
            addressDialogVisible:false,
            fileDialogVisible:false,
            feedbackDialogVisible:false,
        }
    }

    generateHtmlString = () => {
        let p = this.props.ele;
        return (
            <div key={"buttonpanel_" + p.Sequence} className="button-panel-container">
                <div
                    style={{ display: p.Sequence == 1 ? "none" : "block" }}
                    className="panel-button"
                    key={"moveup_" + p.Id}
                    onClick={(e) => {
                        p.parent.ListOfFormSectionElements[p.Sequence - 2].Sequence =
                            p.parent.ListOfFormSectionElements[p.Sequence - 2].Sequence + 1;
                        p.Sequence = p.Sequence - 1;
                        this.props.callback(p.parent.parent.parent);
                    }}
                >
                    Move Up
                </div>
                <div
                    style={{
                        display:
                            p.Sequence == p.parent.ListOfFormSectionElements.length
                                ? "none"
                                : "block",
                    }}
                    className="panel-button"
                    onClick={(e) => {
                        p.parent.ListOfFormSectionElements[p.Sequence].Sequence =
                            p.parent.ListOfFormSectionElements[p.Sequence].Sequence - 1;
                        p.Sequence = p.Sequence + 1;
                        this.props.callback(p.parent.parent.parent);
                    }}
                >
                    Move Down
                </div>
                <div className="panel-button" onClick={() => this.showConfirmation()}>
                    Remove
                </div>
                <div
                    className="panel-button"
                    onClick={() => {
                        if (this.props.ele.Editable == "Y" || this.props.ele.Datatype == "Table") {
                            switch (this.props.ele.Datatype) {
                                case "Date":                           
                                    this.setState({ dateDialogVisible: true });
                                    break;
                                   case "DateTime":
                                    this.setState({ dateTimeDialogVisible: true });
                                    break;
                                case "Table":
                                case "Excel Template":
                                    this.setState({ tableRuleDialogVisible: true });
                                    break;
                                case "Text":
                                case "MultiText":
                                    this.setState({ textDialogVisible: true });
                                    break;

                                case "Excel":
                                    this.setState({ excelDialogVisible: true });
                                    break;
                                case "Label":
                                        this.setState({ labelDialogVisible: true });
                                        break;
                                case "Button":
                                case "RecaptchaButton":
                                case "PublicSecureButton":
                                    this.setState({ buttonDialogVisible: true });
                                    break;
                                case "Address":
                                    this.setState({addressDialogVisible:true});
                                    break;
                                case "File":
                                    this.setState({fileDialogVisible:true});
                                    break;
                                case "Feedback":
                                case "TechError":
                                    this.setState({feedbackDialogVisible:true});
                                    break;
                                default:
                                    this.setState({ defaultDialogVisible: true });
                            }
                        } else {
                            this.setState({ readonlyDialogVisible: true });
                        }
                    }}>
                    More...
                </div>
                {/* @ts-ignore */}
                <ConfirmDialog
                    key={"confirmDialog_"}
                    visible={this.state.confirmDialogVisible}
                    message="Are you sure you want to remove this section?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    acceptLabel="Yes"
                    rejectLabel="No"
                    closable = {false}
                    accept={() => {
                        this.removeSection();
                        this.setState({ confirmDialogVisible: false });
                    }}
                    reject={() => this.setState({ confirmDialogVisible: false })}
                />
            </div>
        );
    };

    showConfirmation = () => {
        this.setState({ confirmDialogVisible: true });
    };

    removeSection = () => {
        let p = this.props.ele;
        const listSection = p.parent.ListOfFormSectionElements.filter(p => p.Sequence!== this.props.ele.Sequence)
        p.parent.ListOfFormSectionElements = listSection;
        this.props.callback(p.parent.parent.parent);
    };

    render() {
        let basicHtmlString = [];
        basicHtmlString.push(this.generateHtmlString());

        if (this.state.dateDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' && this.props.ele.Datatype === 'Date' ? 'block' : 'none' }}>
                    <DialogForDateComponent  key={"Date_"} ele={this.props.ele} dialogVisible={this.state.dateDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dateDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>

                    </DialogForDateComponent>
                </div>
            )
        }
        if (this.state.dateTimeDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' &&  this.props.ele.Datatype === 'DateTime' ? 'block' : 'none' }}>
                    <DialogForDateTimeComponent  key={"Date_"} ele={this.props.ele} dialogVisible={this.state.dateTimeDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dateTimeDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>

                    </DialogForDateTimeComponent>
                </div>
            )
        }
        if (this.state.textDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' && (this.props.ele.Datatype === 'Text' || this.props.ele.Datatype === 'MultiText') ? 'block' : 'none' }}>
                    <DialogForTextComponent  key={"Text_"} ele={this.props.ele} dialogVisible={this.state.textDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ textDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>

                    </DialogForTextComponent>
                </div>
            )
        }
        
        if (this.state.buttonDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'Button' ? 'block' : 'none' }}>
                    <DialogForButtonComponent  key={`button_${this.props.ele.Id} `} ele={this.props.ele} dialogVisible={this.state.buttonDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ buttonDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>

                    </DialogForButtonComponent>
                </div>
            )
        }

        if (this.state.defaultDialogVisible) {
            if(this.props.ele.Datatype=="Row"){
                // if(this.props.ele.ListOfFormSubSections!=null)
            }

            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' ? 'block' : 'none' }}>
                    <DialogForDefaultComponent  key={"Default_"} ele={this.props.ele} dialogVisible={this.state.defaultDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ defaultDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>

                    </DialogForDefaultComponent>
                </div>
            )
        }

        if (this.state.readonlyDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForReadonlyComponent  key={"Readonly_"} ele={this.props.ele} dialogVisible={this.state.readonlyDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ readonlyDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialogForReadonlyComponent>
                </div>
            )
        }

        if (this.state.tableRuleDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForTableRuleComponent key={"TableDialog_"} ele={this.props.ele} dialogVisible={this.state.tableRuleDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ tableRuleDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialogForTableRuleComponent>
                </div>
            )
        }

        if (this.state.excelDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogforExcelComponent key={"TableExcel_"} ele={this.props.ele} dialogVisible={this.state.excelDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ excelDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialogforExcelComponent>
                </div>
            )
        }
        if (this.state.labelDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForLabelComponent key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.labelDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ labelDialogVisible: false })
                            }
                             this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialogForLabelComponent>
                </div>
            )
        }
        if (this.state.addressDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialongforAddressComponent key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.addressDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ addressDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialongforAddressComponent>
                </div>
            )
        }

        if (this.state.fileDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForFileComponent key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.fileDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ fileDialogVisible: false })
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialogForFileComponent>
                </div>
            )
        }

        if (this.state.feedbackDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForFeedbackComponent key={"feedback_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.feedbackDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ feedbackDialogVisible: false });
                            }
                            this.props.callback(this.props.ele.parent.parent.parent);
                        }}>
                    </DialogForFeedbackComponent>
                </div>
            )
        }

        return (
            basicHtmlString
        )
    }
}